/**
 * Registration rules, mirrored from the server
 * (mushroom-bank/lambda/routes/email_verification.py). The server is the
 * authority and checks everything again; this only saves the round trip, and
 * returns the SAME error codes so one set of translations covers both.
 */
export const MIN_PASSWORD_LENGTH = 10;
// The most bcrypt hashes, in UTF-8 BYTES: a Hebrew letter counts as two.
export const MAX_PASSWORD_BYTES = 72;
export const USERNAME_RE = /^[A-Za-z0-9][A-Za-z0-9._-]{2,63}$/;

export function usernameProblem(username) {
  if (!username) return 'username_required';
  if (!USERNAME_RE.test(username)) return 'username_invalid';
  // Deleted accounts are renamed deleted-<hex>; a person must not be able to
  // pick a name that looks like one.
  if (username.toLowerCase().startsWith('deleted-')) return 'username_reserved';
  return null;
}

// A lone UTF-16 surrogate: not text UTF-8 can carry. TextEncoder would quietly
// turn it into U+FFFD; the server refuses it as password_invalid.
const LONE_SURROGATE = /\p{Cs}/u;

export function passwordProblem(password, username = '', email = '') {
  if (!password) return 'password_required';
  if (LONE_SURROGATE.test(password)) return 'password_invalid';
  if (password.length < MIN_PASSWORD_LENGTH) return 'password_too_short';
  if (new TextEncoder().encode(password).length > MAX_PASSWORD_BYTES) return 'password_too_long';
  if (!/[A-Za-z]/.test(password) || !/\d/.test(password)) return 'password_too_weak';
  const lowered = password.toLowerCase();
  const parts = [username, (email || '').split('@')[0]];
  for (const part of parts) {
    if (part && part.length >= 3 && lowered.includes(part.toLowerCase())) {
      return 'password_contains_identity';
    }
  }
  return null;
}
